import { z } from "zod"

export const B2CSignUpSchema = z.object({
  title: z.string().min(1, { message: "Title is required!" }),
  firstName: z.string().min(1, { message: "First name is required!" }),
  lastName: z.string().min(1, { message: "Last name is required!" }),
  email: z.string().email({ message: "Email is required" }),
  password: z.string().min(1, { message: "Password is required!" }),
})

export type B2CSignUpForm = z.infer<typeof B2CSignUpSchema>

export const B2BSignUpSchema = z.object({
  companyName: z.string().min(1, { message: "Company name is required!" }),
  title: z.string().min(1, { message: "Title is required!" }),
  firstName: z.string().min(1, { message: "First name is required!" }),
  lastName: z.string().min(1, { message: "Last name is required!" }),
  email: z.string().email({ message: "Email is required" }),
  password: z.string().min(1, { message: "Password is required!" }),
})

export type B2BSignUpForm = z.infer<typeof B2BSignUpSchema>
